<template>
  <form class="change-password-container" @submit.prevent>
    <div class="edit-form-title">
      <h1>Change Password</h1>
    </div>
    <div class="change-password-form">
      <label>Current Password <span class="required-flag">*</span></label>
      <div>
        <input class="old-password" id="oldPassword"
        name="oldPassword" type="password" v-model="oldPassword">
      </div>
    </div>
    <div class="change-password-form">
      <label>New Password <span class="required-flag">*</span></label>
      <div>
        <input class="new-password" id="newPassword"
        name="newPassword" type="password" v-model="newPassword"
        ref="password">
      </div>
    </div>
    <div class="change-password-form">
      <label>Confirm Password <span class="required-flag">*</span></label>
      <div>
        <input class="confirm-password" id="confirmPassword"
        name="confirmPassword" type="password" v-model="confirmPassword">
      </div>
    </div>
    <div class="change-password-form">
      <button class="update" @click="submit" aria-label="Update Password" type="submit">
        Update Password
      </button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'change-password',
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
  },
  methods: {
    async submit() {
      const { oldPassword, newPassword, confirmPassword } = this;
      try {
        if (newPassword !== confirmPassword) {
          this.$toasted.show('New passwords do not match', {
            type: 'info',
          });
          return;
        }
        const passwordChangeResponse = await this.backendAxios.post('/auth/password/change', {
          oldPassword,
          newPassword,
        });
        if (passwordChangeResponse) {
          this.$toasted.show('Password Successfully Changed', {
            type: 'info',
          });
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
        }
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.change-password-container {
  padding: 0 0 2rem 0;
}

.change-password-header {
  display: flex;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1rem;
  padding: 1rem;
  background-color: #E8e8E8;
}

.change-password-form {
  display: flex;
  align-items: top;
  justify-content: center;
  padding: 0.5rem;
  margin: 0.5rem 0;
}

.change-password-form label {
  width: 10rem;
  padding: 0.75rem;
  text-align: right;
  font-size: 1rem;
}

.change-password-form input {
  text-indent: 0.3rem;
  width: 15rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: normal;
  color: #484848;
  background-color: white;
  height: 2rem;
  border: 1px solid #DCDBDB;
  border-radius: 0.1rem;
}

.change-password-form .update {
  cursor: pointer;
  padding: 0.75rem 1rem;
  border-radius: 0.2rem;
  color: #fff;
  background-color: $login-background;
  font-size: 1rem;
  border-color: $login-background;
  font-weight: 800;
  margin: 2rem 0 0 0rem;
  white-space: nowrap;
  letter-spacing: .025em;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  &:hover {
    background-color: $login-hover;
    border-color: $login-hover;
  }
}

.error-text {
  color: $error-text !important;
  font-size: 0.8rem;
  padding-top: 0.5rem;
  width: 15rem;
}

.required-flag {
  color: red;
}
</style>
